import React, {useEffect, useState} from "react";
import {Button, ButtonGroup, IconButton, Popover, Tooltip, Typography} from "@mui/material";
import {Apps, KeyboardBackspace} from "@mui/icons-material";
import css_buttons from "../components/Common/css/CCButton.module.scss";
import {useNavigate} from "react-router-dom";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import DeveloperLogTableApplet from "../eoec/applet/impl/LogManagement/DeveloperLogTableApplet";
import DeveloperMenu from "../components/Navigation/DeveloperMenu";


type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option: string | null}
type LogWindow = "today" | "7d" | "all"

const LOG_WINDOWS: {id: LogWindow; label: string}[] = [
    {id: "today", label: "Today"},
    {id: "7d", label: "Last 7 days"},
    {id: "all", label: "All"},
]

export default function DashboardLogManagement() {
    const [developerLogEnterpriseObject] = useState(enterpriseObjectClassFactory("DeveloperLog") as EnterpriseObject);
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);
    const [logWindow, setLogWindow] = useState<LogWindow>("today");

    const navigate = useNavigate();

    useEffect(() => {
        const ec = developerLogEnterpriseObject.getEnterpriseComponent("DeveloperLog") as any;
        ec?.setIDOCRequest("v1.DeveloperLog-001");
        ec?.setIDOCResponse("v1.DeveloperLog-001");
        if (ec?.setLogWindow) {
            ec.setLogWindow(logWindow);
        }

        return () => {}
    }, [developerLogEnterpriseObject, logWindow]);

    function onLogWindowChange(window: LogWindow) {
        if (window === logWindow) {
            return;
        }
        setLogWindow(window);
        const ec = developerLogEnterpriseObject.getEnterpriseComponent("DeveloperLog") as any;
        if (ec?.setLogWindow) {
            ec.setLogWindow(window);
        }
        // Invalidate triggers EnlilTable to re-query with the new Window param.
        ec?.invalidate();
    }

    function renderContent() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: "50px", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                    <div style={{display: "flex", flexDirection: "row", paddingTop: "9px", marginLeft: "20px"}}>
                        <IconButton
                            className={css_buttons.whiteStandardButton} style={{marginLeft: "-20px", marginTop: "-2px", cursor: "pointer"}} size="small"
                            onClick={() => {
                                navigate("/dashboard");
                            }}>
                            <KeyboardBackspace sx={{color: "#1498D8", width: "30px", height: "30px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>Log Management</Typography>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: "30px", gap: "12px"}}>
                        <Typography style={{fontSize: 13, color: "#6B7280"}}>Show</Typography>
                        <ButtonGroup size="small" variant="outlined">
                            {LOG_WINDOWS.map((option) => (
                                <Button
                                    key={option.id}
                                    onClick={() => onLogWindowChange(option.id)}
                                    variant={logWindow === option.id ? "contained" : "outlined"}
                                    style={{
                                        textTransform: "none",
                                        backgroundColor: logWindow === option.id ? "#1498D8" : undefined,
                                        color: logWindow === option.id ? "#FFFFFF" : "#1498D8",
                                        borderColor: "#1498D8",
                                    }}
                                >
                                    {option.label}
                                </Button>
                            ))}
                        </ButtonGroup>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", paddingRight: "60px"}}>
                    <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                        <DeveloperLogTableApplet enterpriseComponent={developerLogEnterpriseObject?.getEnterpriseComponent("DeveloperLog")}/>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Dashboard</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginRight: "15px"}}>
                    <Tooltip title={"Administration Menu"}>
                        <IconButton className={css_buttons.blueIconButton2} style={{marginTop: "11px"}} onClick={(e) => setMenu({id: "administrationAppsMenu", target: e.currentTarget, option: null})}>
                            <Apps/>
                        </IconButton>
                    </Tooltip>
                    {menu?.id === "administrationAppsMenu" ? (
                        <Popover anchorEl={menu.target}
                                 anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                 transformOrigin={{vertical: -11, horizontal: "left"}}
                                 open={true}
                                 onClose={() => setMenu(null)}
                                 TransitionProps={{
                                     onExited: () => setMenu(null),
                                 }}
                                 PaperProps={{
                                     elevation: 2,
                                 }}
                        >
                            <DeveloperMenu/>
                        </Popover>
                    ) : null}
                </div>
            </div>
            {renderContent()}
        </div>
    );
}